export default __webpack_public_path__ + "static/media/dash-create-shipment.96ce18dd.png";